import { combineReducers } from 'redux';

import playbookType from './playbook_type/reducer';
import playbooks from './playbooks/reducer';
import stage from './stage/reducer';
import status from './status/reducer';

export default combineReducers({
  canEditPropertyTypes: canEditPropertyTypes => canEditPropertyTypes || false,
  canRequirePlaybookTasks: canRequirePlaybookTasks => canRequirePlaybookTasks || false,
  offices: offices => offices || [],
  paths: paths => paths || {},
  playbookRecordType: playbookRecordType => playbookRecordType || 'deal',
  playbooks,
  playbookType,
  playbookTypeOptions: options => options || [],
  propertyTypeOptions: options => options || [],
  stages: stages => stages || {},
  stage,
  status,
  statusOptions: options => options || [],
  users: users => users || []
});
